type TRocketleague =
|'name'
|'maps.dfh-stadium'
;
const RocketleagueNS = 'rocketleague';
function RocketleagueF(_: TRocketleague): string { return `${RocketleagueNS}:${_}`; }
export {RocketleagueF,RocketleagueNS,TRocketleague};
